<template>
    <div v-separator-link="200">
        <div class="gcmcn-form-title">{{ user ? 'Edit' : 'Add'}} a user</div>
        <div class="gcmcn-card">
            <el-form :model="form" :rules="rules" ref="form">
                <el-form-item class="gcmcn-form-input" prop="email">
                    <div class="gcmcn-form-label">Email</div>
                    <el-input
                        size="mini"
                        v-model="form.email"
                    ></el-input>
                </el-form-item>
                <div class="text-right">
                    <el-button
                        type="text"
                        @click="leave"
                    >Cancel</el-button>
                    <el-button
                        :loading="loading"
                        type="primary"
                        class="gcmcn-primary-btn small"
                        @click="validateForm"
                    >Save
                    </el-button>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {

    components: {
    },

    props: {
        user: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
        takerGroup: {
            type: Object,
            required: true
        },
        scopes: {
            type: Object,
            required: true
        }
    },

    data (){
        return {
            form: {
                email: '',
            },
            loading: false,
        };
    },

    computed: {
        rules () {
            return {
                email: [{ required: true }],
            };
        },

    },

    watch: {
        user: {
            handler (){
                this.setForm();
            },
            deep: true,
            immediate: true,
        }
    },

    created (){
    },

    methods: {
        setForm (){
            if(this.user){
                this.$set(this, 'form', JSON.parse(JSON.stringify(this.user)));
            }else{
                this.$set(this, 'form', { email: '' });
            }
        },
        validateForm (){
            this.$refs.form.validate((valid) => {
                if(valid){
                    this.loading = true;
                    let form = JSON.parse(JSON.stringify(this.form));
                    let action;
                    let postData = { item: form, model: 'users'};
                    let messageType = this.user ? 'update' : 'create';
                    if(this.user){
                        action = 'patchItem';
                        this.form.url = this.user.url;

                    }else{
                        postData = form;
                        action = 'fundation/createUserAccount';
                        postData.scopes = {'X-Entity-Uid': this.scopes.entity_uid};
                    }
                    this.$store.dispatch(action, postData).then(async (res) => {
                        this.$store.dispatch('fundation/addUsersToGroup', {
                            users: [res],
                            group: this.takerGroup
                        });
                    }).then(() => {
                        this.$emit('on-user-created', `User ${messageType}d!`);
                        this.loading = false;
                    }).catch((e) => {
                        console.error(e);
                        this.$message.error(`Error on user ${messageType === 'update' ? messageType : 'creation'}.`);
                        this.loading = false;
                    });
                }
            });
        },
        leave (){
            this.$emit('leave-form-view');
        },
    },
};
</script>

<style lang="scss">
.crop-rules{
    text-transform: initial;
    color: #bbb;
}
.inputs-container{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .flex-basis-5{
        flex-basis: calc( 50% - 10px);
    }
    .flex-basis-10{
        flex-basis: 100%;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/page/Takers/user-form.vue